import { render, staticRenderFns } from "./employee-education.vue?vue&type=template&id=55b8ccce"
import script from "./employee-education.vue?vue&type=script&lang=js"
export * from "./employee-education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports